import React, { useState, useEffect } from 'react';
import Hero from '../common/Hero';
import Footer from '../common/Footer';
import { initAnimations } from '../../utils/animations';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formResponse, setFormResponse] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    initAnimations();
  }, []);

  const breadcrumbs = [
    { text: 'Home', link: '/' },
    { text: 'Contact' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('/sendmail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.text();
      setFormResponse(data);
      
      if (response.ok) {
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      }
    } catch (error) {
      setFormResponse('There was an error submitting your message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Hero 
        title="Contact"
        breadcrumbs={breadcrumbs}
      />

      <div className="container-fluid contact py-5">
        <div className="container py-5">
          <div className="text-center mx-auto mb-5 wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
            <p className="fs-5 text-uppercase text-primary">Get In Touch</p>
            <h1 className="display-3">Contact Us</h1>
            <p className="mb-0">
              Have questions or need assistance? Reach out to us through the form below or visit us at the mosque. 
              We'll respond as soon as possible.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.3s">
              <form id="contactForm" onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input 
                      type="text" 
                      name="name" 
                      className="form-control bg-transparent p-3" 
                      placeholder="Your Name" 
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <input 
                      type="email" 
                      name="email" 
                      className="form-control bg-transparent p-3" 
                      placeholder="Your Email" 
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12">
                    <input 
                      type="text" 
                      name="subject" 
                      className="form-control bg-transparent p-3" 
                      placeholder="Subject" 
                      required
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12">
                    <textarea 
                      name="message" 
                      className="w-100 form-control bg-transparent p-3" 
                      rows="6" 
                      cols="10" 
                      placeholder="Your Message" 
                      required
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-12 text-center">
                    <button 
                      className="btn btn-primary border-0 py-3 px-5" 
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </div>
              </form>
              {formResponse && (
                <div id="formResponse" className={`mt-3 alert ${formResponse.includes('Thank you') ? 'alert-success' : 'alert-danger'}`}>
                  {formResponse}
                </div>
              )}
            </div>
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="bg-light p-4">
                  <div className="d-flex align-items-center mb-4">
                    <div className="btn-square bg-primary rounded-circle me-3">
                      <i className="fa fa-map-marker-alt text-white"></i>
                    </div>
                    <h6 className="mb-0">Address</h6>
                  </div>
                  <p className="mb-0"> 15200 Broadway Ave, Harvey, IL 60426</p>
                </div>
                <div className="bg-light p-4">
                  <div className="d-flex align-items-center mb-4">
                    <div className="btn-square bg-primary rounded-circle me-3">
                      <i className="fa fa-phone-alt text-white"></i>
                    </div>
                    <h6 className="mb-0">Phone</h6>
                  </div>
                  <p className="mb-0">+1 (234) 567-8900</p>
                  <p className="mb-0">+1 (234) 567-8901 (Emergency)</p>
                </div>
                <div className="bg-light p-4">
                  <div className="d-flex align-items-center mb-4">
                    <div className="btn-square bg-primary rounded-circle me-3">
                      <i className="fa fa-envelope text-white"></i>
                    </div>
                    <h6 className="mb-0">Email</h6>
                  </div>
                  <p className="mb-0">support@harveymasjid.com</p>
                  <p className="mb-0">info@harveymasjid.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;